export default __webpack_public_path__ + "static/media/research-man.cc419285.svg";